import { addNotify } from 'features/notify';

const actionTypes = {
  ACTION_PROCESSING: 'promotions/ACTION_PROCESSING',
  SET_POINTS_DATA: 'promotions/SET_POINTS_DATA',
};

const getPoints = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

  const response = await api.promotions.getPoints();

  if (response.success) {
    dispatch({ type: actionTypes.SET_POINTS_DATA, payload: response.data });
  } else {
    const { locale } = getState().locale;
    const errorMessage = locale[response.codeStatus] ?? (response.errorMessage || locale.defaultMessage);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
}

export { actionTypes, getPoints };
